import { computed, reactive } from "vue";
import dashboardApi from "../api";

export default function (type, chartType = "bar") {
  const data = reactive({
    series: [
      {
        data: [],
      },
    ],
    options: {
      chart: {
        fontFamily: "Source Sans Pro, Arial, sans-serif",
        type: chartType,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true,
        },
      },
      colors: ["#5B9BD5"],
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        labels: {
          maxWidth: 400,          
          style: {
            fontSize: "15px",
          },
        },
        forceNiceScale: true,
      },
      tooltip: {
        theme: "dark",
        x: {
          show: false,
        },
        y: {
          formatter: (v, data) => { 
            return data.w.globals.labels[data.dataPointIndex] + ": " + v + " чел.";
          },
          title: {
            formatter: function () {
              return "";
            },
          },
        },
      },
    },
  });
  const loadReport = async () => {
    const res = await dashboardApi.getRASReport({ type });
    data.options.chart.height = 100 + res.data.length * 20;
    Object.assign(data, {
      ...data,
      series: [{ name: "", data: res.data.map((item) => item.count) }],
      options: {
        ...data.options,
        xaxis: {
          categories: res.data.map((item) =>
            item.text.replace("Нижний Новгород", "НН"))
        },
      },
    });
  };
  loadReport();
  return {
    data: computed(() => data),
    loadReport,
  };
}
